module.exports = __webpack_public_path__ + "static/media/201EE203.f0a4ba49.jpg";